import { Route, Switch } from "react-router-dom";
import { connect } from "react-redux";
import TabsMenu from "../TabsMenu";
import Page404 from "../Page404";
import LoadDocuments from "./LoadDocuments";
import QRCode from "components/QRCode/QRCode";

const SPLIT_TABS = ["Aktive Dokumente", "Erledigt"];
const SIGN_TABS = ["Entwurf", "In Bearbeitung", "Erledigt"];

const Documents = (props) => {
  const { id, services, fullName } = props;
  const { status } = props.match.params;
  const defaultPath = props.match.path.split("/:")[0];

  return (
    <Switch>
      {services?.map((service) => {
        let tabs =
          service.serviceType === "signature_envelopes"
            ? [...SIGN_TABS]
            : [...SPLIT_TABS];

        const showExportTab =
          service?.serviceModules?.modules_on_finish?.find(
            (module) => module?.["-name"] === "synop.esign",
          )?.["-sendWithReference"] !== undefined;

        if (showExportTab && service.serviceType === "signature_envelopes") {
          tabs = [
            "Entwurf",
            "In Unterschrift",
            "Unterschriften abgeschlossen",
            "Erledigt",
          ];
        }

        return (
          <Route
            exact
            key={service.id}
            path={tabs.map(
              (_, index) => `${defaultPath}/${service.id}/${index}`,
            )}
            render={() => (
              <TabsMenu
                title={"dokumente"}
                serviceType={service.serviceType}
                subtitle={service.name}
                tabs={tabs}
                service={service}
                defaultPath={`${defaultPath}/${service.id}`}
                pageTitle={"d-none d-md-block"}
              >
                {["detect_types"].includes(service.serviceType) ? (
                  <QRCode
                    serviceId={service.id}
                    userId={id}
                    serviceName={service.name}
                    userName={fullName}
                  />
                ) : null}
                {service.id === "error" ? (
                  <Page404 height="100%" />
                ) : (
                  <LoadDocuments {...service} status={status} />
                )}
              </TabsMenu>
            )}
          />
        );
      })}
      <Route component={Page404} />
    </Switch>
  );
};

/**
 * Take services from redux store and return it
 * in components props.
 */
const mapStateToProps = ({ userData: { services, id, fullName } }) => ({
  services,
  id,
  fullName,
});

export default connect(mapStateToProps)(Documents); //Export component and connect it with redux.
